// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require('webpack-jquery-ui');
require('webpack-jquery-ui/css');
require("selectize")
require("easy-autocomplete")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "bootstrap";
import "../stylesheets/application";
import "./custom";
import "./company";
import "./deposits";
import "./invoices";
import "./cupoms";
import "./order";
import "./user";
import "./product";
import "./product_warn";
import "./sb-admin-2";
import "./jquery.mask";
import "./jquery.easing.min";
import "@fortawesome/fontawesome-free/js/all";
import "sweetalert2/dist/sweetalert2.min"
import Inputmask from "inputmask";
import 'cocoon-js'

window.Swal = require('sweetalert2') // added here
